export default __webpack_public_path__ + "static/media/SJA1350.34I-40946_-24272_0.a2b179d6.jpg";